import { IComData } from "@/common/interface";
import { SET_COM_DATA } from "../actionTypes";
import { Dispatch } from "react";
import { getPmpData } from "@/common/api";

export { setAppStatus, setAppProgress } from "@/store/common/action/appStatus";

export const setComData = (data: IComData) => ({
  type: SET_COM_DATA,
  data,
});

export const asyncGetPmpData = () => {
  return (dispatch: Dispatch<any>) =>
    getPmpData(["Sj2foR"]).then((res) => {
      if (res.adspaces) {
        return dispatch(setComData(res));
      }
      throw new Error("商业化错误");
    });
};
